
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cls-1",attrs:{"d":"M6 20a1 1 0 001 1h10a1 1 0 001-1l1-13H5zm9.5-17l-.22-.45a1 1 0 00-.9-.55H9.62a1 1 0 00-.9.55L8.5 3H4v2h16V3z"}})])
          )
        }
      }
    